// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import DefaultButton from 'app/components/commons/button/DefaultButton';
// consts
import { COLORS } from 'app/config/colors';

function ClearButton({ onClick }) {
  return (
    <DefaultButton
      tag={<u>LIMPAR</u>}
      size='small'
      onClick={onClick}
      color={COLORS.PRIMARY_VARIANT_DARK}
      colorHover={COLORS.PRIMARY_VARIANT_DARK}
      backgroundColor={COLORS.TRANSPARENT}
      backgroundColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
      borderColor={COLORS.TRANSPARENT}
      borderColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
    />
  );
}

ClearButton.propTypes = {
  onClick: PropTypes.func
};

export default ClearButton;
